import React from 'react';
import PropTypes from 'prop-types';
import { productsShape, bookingShape } from 'constants/propTypes';
import { DIRECTIONS } from 'types/classes';
import { findDirectionOfProductByItemRef } from '../../AfterSalesCtas/AfterSalesCtas.utils';
import { applyCheckBoxRules } from '../JourneyLegs.utils';

const BookingItemCheckBox = ({
  isMultiInventory,
  isMultiJourney,
  bookingItem: { itemRef, cancelled, associatedItemRefs },
  isGroupChecked,
  toggleGroup,
  legBookingItems,
  addOnLeg,
  isOutboundSummatedFare,
  isInboundSummatedFare,
  selectItemIndependently,
  booking: { outbound, inbound },
  booking
}) => {
  const directionOfItem = findDirectionOfProductByItemRef(booking, itemRef);
  const associatedItemReferences = [...associatedItemRefs];
  const addOnItemRefs = addOnLeg ? addOnLeg.bookingItems.map((bi) => bi.itemRef) : [];
  associatedItemReferences.push(itemRef);

  const itemRefs = selectItemIndependently
    ? [itemRef]
    : (() => {
        if (directionOfItem === DIRECTIONS.OUTBOUND) {
          return applyCheckBoxRules({
            segments: outbound,
            legBookingItems,
            isSummatedFare: isOutboundSummatedFare,
            isMultiInventory,
            isMultiJourney,
            associatedItemReferences,
            itemRef,
            addOnItemRefs
          });
        }

        if (directionOfItem === DIRECTIONS.INBOUND) {
          return applyCheckBoxRules({
            segments: inbound,
            legBookingItems,
            isSummatedFare: isInboundSummatedFare,
            isMultiInventory,
            isMultiJourney,
            associatedItemReferences,
            itemRef,
            addOnItemRefs
          });
        }

        if (isMultiJourney) return [itemRef];
        return associatedItemReferences.filter((ref) => !addOnItemRefs.includes(ref));
      })();

  return <input type="checkbox" onChange={toggleGroup(itemRefs)} checked={isGroupChecked(itemRefs)} disabled={cancelled} />;
};

BookingItemCheckBox.propTypes = {
  legBookingItems: productsShape,
  bookingItem: PropTypes.shape({
    itemRef: PropTypes.string,
    cancelled: PropTypes.bool,
    associatedItemRefs: PropTypes.arrayOf(PropTypes.string)
  }),
  toggleGroup: PropTypes.func.isRequired,
  isGroupChecked: PropTypes.func.isRequired,
  isMultiInventory: PropTypes.bool,
  isMultiJourney: PropTypes.bool,
  addOnLeg: PropTypes.shape({
    bookingItems: productsShape
  }),
  isOutboundSummatedFare: PropTypes.bool,
  isInboundSummatedFare: PropTypes.bool,
  selectItemIndependently: PropTypes.bool,
  booking: bookingShape
};

export default BookingItemCheckBox;
